import React, {PropTypes} from 'react';
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import {iconFactory} from '../../../Icons/index';

let styles = {
  tableHeaderText: {
    textAlign: 'center',
    padding: '10px 5px',
    fontSize: 10,
    fontWeight: 100,
    backgroundColor: '#1C2954',
    color: '#fff',
    borderLeft: '1px solid #fff'
  },
  tableBodyText: {
    backgroundColor: '#EFF0F1',
    borderLeft: '1px solid #fff',
    textAlign: 'center',
    verticalAlign: 'middle',
    padding: 0
  },
  icons: {
    width: 30,
    height: 30,
    color: '#fff'
  },
  radioButton: {
    width: 'auto',
    margin: '70px auto 95px',
    color: '#911630',
    textAlign: 'center'
  },
  lastRadioButton: {
    width: 'auto',
    margin: '95px auto 90px',
    color: '#911630',
    textAlign: 'center'
  },
  noShopBanner: {
    width: 'auto',
    margin: '45px auto 105px',
    color: '#911630',
    textAlign: 'center'
  }
};

class RadioButtonContainer extends React.Component {
  render() {
    const {field, bannerList, modules} = this.props;
    return (
      <RadioButtonGroup
        name='ModuleBannerPosition'
        onChange={(event, value) => {
          field.onChange(value);
        }}
        valueSelected={field.value}
        defaultSelected={field.value}
        style={{marginTop: 75, marginBottom: 75}}
      >
        {bannerList.map((banner, key) => (
          <RadioButton
            key={key}
            value={banner}
            style={modules.shop ? styles.radioButton : styles.noShopBanner}
            iconStyle={{justifyContent: 'center'}}
          />
        ))}
        <RadioButton
          value='empty'
          style={modules.shop ? styles.lastRadioButton : styles.noShopBanner}
        />
      </RadioButtonGroup>
    );
  }
}

export default class FormTable extends React.Component {
  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  render() {
    let {modules} = this.props;
    let {palette: {hintColor}, tableHeaderColumn} = this.context.muiTheme;

    styles.tableHeaderText.backgroundColor = tableHeaderColumn.bgColor;

    return (
      <Table selectable={false}>
        <TableHeader adjustForCheckbox={false} displaySelectAll={false} enableSelectAll={false}>
          <TableRow>
            {modules.map((module, index) => (
              <TableHeaderColumn
                key={module.name + index}
                style={{...styles.tableHeaderText, color: hintColor || styles.tableHeaderText.color}}>
                <div> {this.renderBannerModuleIcon(module.icon)} </div>
                <div style={{lineHeight: '11px', marginTop: '4px'}}>
                  {module.name}
                </div>
              </TableHeaderColumn>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          <TableRow>
            {modules.map((module, index) => (
              <TableRowColumn key={module.name + index} style={styles.tableBodyText}>
                <RadioButtonContainer field={this.props[module.type]} bannerList={this.props.bannerList}
                                      modules={modules}/>
              </TableRowColumn>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  renderBannerModuleIcon(name) {
    let iconParams = {
      style: {
        width: 25,
        height: 25,
        color: '#fff'
      }
    };

    return React.createElement(iconFactory(name), iconParams);
  }
}



// WEBPACK FOOTER //
// ./src/components/Partner/PartnerBannerForm/PartnerBannerFormTable/PartnerBannerFormTable.jsx